import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { ArticleCard } from '@/components/article/ArticleCard';
import { Button } from '@/components/ui/button';
import { categoriesApi, postsApi } from '@/lib/api';

const CategoryPage = () => {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, [slug]);

  const fetchData = async () => {
    try {
      setLoading(true);
      
      // Fetch all categories and find the matching one
      const categories = await categoriesApi.getPublicCategories();
      const matchedCategory = categories.find(c => c.slug === slug);
      
      if (!matchedCategory) {
        setError('Kategori bulunamadı');
        setLoading(false);
        return;
      }
      
      setCategory(matchedCategory);
      
      // Fetch posts for this category
      const postsData = await postsApi.getPublicPosts({ category: slug, limit: 100 });
      setPosts(postsData.posts);
      
    } catch (error) {
      console.error('Failed to fetch category:', error);
      setError('Kategori yüklenirken hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[60vh]">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </Layout>
    );
  }

  if (error || !category) {
    return (
      <Layout>
        <div className="container-article py-20 text-center">
          <h1 className="heading-section text-foreground mb-4">Kategori Bulunamadı</h1>
          <p className="text-muted-foreground mb-8">Aradığınız kategori mevcut değil.</p>
          <Link to="/kategoriler">
            <Button variant="outline">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Kategorilere Dön
            </Button>
          </Link>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      {/* Header */}
      <section className="container-wide py-12 sm:py-16">
        <div className="max-w-2xl">
          {/* Back Link */}
          <Link 
            to="/kategoriler" 
            className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6"
          >
            <ArrowLeft className="h-4 w-4" />
            Tüm Kategoriler
          </Link>

          <span className="caption text-accent mb-2 block">Kategori</span>
          <h1 className="heading-article text-foreground mb-4">{category.name}</h1>
          <p className="body-large text-muted-foreground">
            {category.description}
          </p>
          <p className="text-sm text-muted-foreground mt-4">
            {posts.length} yazı
          </p>
        </div>
      </section>

      {/* Horizontal Rule */}
      <div className="container-wide">
        <div className="h-px bg-border" />
      </div>

      {/* Posts */}
      <section className="container-wide py-12">
        {posts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-8">
            {posts.map((post) => (
              <ArticleCard key={post._id} post={post} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <p className="text-muted-foreground">
              Bu kategoride henüz yazı bulunmuyor.
            </p>
          </div>
        )}
      </section>
    </Layout>
  );
};

export default CategoryPage;
